'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$() {
}
export { $c_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ as $c_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ };
$p = $c_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$;
/** @constructor */
function $h_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$() {
}
export { $h_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ as $h_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ };
$h_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$.prototype = $p;
$p.bsE = (function(user) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sjs_js_Thenable$ThenableOps$().Be(user.getIdToken()).btt(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((input) => input)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_prelude\uff3fclient$package$().arw());
});
$p.bOo = (function(user) {
  var this$4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_effect_IO$();
  var fut = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_effect_IO$().fs(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => $m_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$().bsE(user))));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcats_effect_kernel_Async__fromFuture__O__O(this$4.dn, fut);
});
var $d_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$, "app.webclient_prelude.exts.FirebaseUserExts$package$", ({
  IA: 1
}));
export { $d_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ as $d_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ };
var $n_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$;
function $m_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$() {
  if ((!$n_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$)) {
    $n_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ = new $c_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$();
  }
  return $n_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$;
}
export { $m_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ as $m_Lapp_webclient\uff3fprelude_exts_FirebaseUserExts$package$ };
//# sourceMappingURL=app.webclient_prelude.exts.-Firebase-User-Exts$package$.js.map
